export default __webpack_public_path__ + "static/12-2cc54d8522d6cb956edd6418a296f151.jpg";